import { useEffect } from 'react';

/**
 * When multiple selection is disabled, we need to clear the remaining selected communities.
 * That way, when user enables multiple selection again, no communities will be selected.
 */
export const useRemoveCommunitiesSelection = (
  isMultipleSelection: boolean,
  selectedCommunitiesLength: number,
  setSelectedCommunitiesIds: (ids: number[]) => void
) => {
  useEffect(() => {
    if (!isMultipleSelection && selectedCommunitiesLength) {
      setSelectedCommunitiesIds([]);
    }
  }, [isMultipleSelection, selectedCommunitiesLength, setSelectedCommunitiesIds]);
};
